var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup203(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_203",
    "data-name": "Group 203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.225,
    height: 51.591,
    viewBox: "0 0 30.225 51.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 30.225,
    height: 51.591,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M27.214,0H3.011A3.014,3.014,0,0,0,0,3.011V48.58a3.014,3.014,0,0,0,3.011,3.011h24.2a3.014,3.014,0,0,0,3.011-3.011V3.011A3.014,3.014,0,0,0,27.214,0M2.015,6.7a1.026,1.026,0,0,0,.133.01H28.077a1.012,1.012,0,0,0,.133-.01V42.175H2.015Zm1-4.685h24.2a1,1,0,0,1,1,1V4.7a1.019,1.019,0,0,0-.133-.01H2.148a1.019,1.019,0,0,0-.133.01V3.011a1,1,0,0,1,1-1m24.2,47.56H3.011a1,1,0,0,1-1-1V44.19H28.209v4.39a1,1,0,0,1-1,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M88.944,341.457H82.679a1.008,1.008,0,0,0,0,2.015h6.265a1.008,1.008,0,0,0,0-2.015",
    transform: "translate(-70.699 -295.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M157.779,341.457h-1.616a1.008,1.008,0,0,0,0,2.015h1.616a1.008,1.008,0,0,0,0-2.015",
    transform: "translate(-134.311 -295.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M45.412,341.457H43.8a1.008,1.008,0,0,0,0,2.015h1.616a1.008,1.008,0,0,0,0-2.015",
    transform: "translate(-37.04 -295.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M105.89,19.4a1.023,1.023,0,1,0-1.023-1.023h0A1.026,1.026,0,0,0,105.89,19.4",
    transform: "translate(-90.778 -15.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M77.135,174.316a7.131,7.131,0,0,0-5.218,2.281,1.008,1.008,0,1,0,1.479,1.368,5.1,5.1,0,0,1,7.2-.277q.144.133.278.277a1.007,1.007,0,1,0,1.479-1.368,7.13,7.13,0,0,0-5.218-2.281",
    transform: "translate(-62.023 -150.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M39.314,112.573a15.28,15.28,0,0,0-11.069,4.693,1.008,1.008,0,0,0,1.44,1.41l.008-.008a13.383,13.383,0,0,1,18.926-.315q.161.155.315.315a1.008,1.008,0,0,0,1.456-1.393l-.008-.009a15.28,15.28,0,0,0-11.069-4.693",
    transform: "translate(-24.202 -97.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M58.232,143.448a11.155,11.155,0,0,0-8.141,3.483,1.008,1.008,0,1,0,1.457,1.392,9.241,9.241,0,0,1,13.066-.3q.154.147.3.3a1.008,1.008,0,0,0,1.458-1.392,11.156,11.156,0,0,0-8.142-3.483",
    transform: "translate(-43.12 -124.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M93.413,207.215a2.96,2.96,0,1,0,2.96,2.96h0a2.963,2.963,0,0,0-2.96-2.96m0,3.905a.945.945,0,1,1,.945-.945.935.935,0,0,1-.925.945Z",
    transform: "translate(-78.301 -179.376)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup203);
export default __webpack_public_path__ + "static/media/Group203.00d08a309d816abd037bcdeb573fe34e.svg";
export { ForwardRef as ReactComponent };